import Request from "../utilis/request";
import config from "../config";

export function savePromotion(data) {
    return Request({
        url: config.config.base_url+'/api/promotions',
        method:'post',
        data: data
    })
}
export function getPromotion(id) {
    return Request({
        url: config.config.base_url+'/api/promotions/'+id,
        method:'get',
    })
}
export function updatePromotion(id, data) {
    return Request({
        url: config.config.base_url+'/api/promotions/'+id,
        method:'put',
        data :data
    })
}
export function deletePromotions(ids) {
    return Request({
        url: config.config.base_url+'/api/promotions',
        method:'delete',
        data :ids
    })
}
export function exportToCsv() {
    return Request({
        url: config.config.base_url+'/api/promotions/csv',
        method:'post',
    })
}
export function exportTemplateDiscountCsv() {
    return Request({
        url: config.config.base_url+'/api/template/discount/csv',
        method:'post',
    })
}
export function exportUsageToCsv() {
    return Request({
        url: config.config.base_url+'/api/promotions/usage/csv',
        method:'post',
    })
}

export function checkCodes(data) {
    return Request({
        url:config.config.base_url+'/api/check/codes',
        method:'post',
        data: data
    })
}
